import React from 'react';
import styles from '../../styles/GeneracionCargosAutomaticosStyles/GeneracionCargosAutomaticos.module.css';

function AutomaticChargeForm({ 
  formData, 
  campusOptions, 
  conceptosOptions, 
  ciclosOptions, 
  seccionesOptions,
  onFormChange, 
  onPreview,
  onGenerate, 
  onCancel,
  onDownloadCSV,
  loading,
  loadingPreview,
  showPreview,
  previewCount
}) {
  
  const handlePreview = (e) => {
    e.preventDefault();
    onPreview();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onGenerate();
  };

  return (
    <div className={styles.formContainer}>
      <div className={styles.formCard}>
        <div className={styles.formHeader}>
          <div className={styles.formHeaderIcon}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"/>
            </svg>
          </div>
          <h2 className={styles.formTitle}>Configuración de Cargos Automáticos</h2>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGrid}>
            {/* Ciclo Escolar - No filtra estudiantes, pero se asocia al cargo */}
            <div className={styles.formField}>
              <label className={styles.fieldLabel}>
                <span className={styles.required}>*</span> Ciclo Escolar <span className={styles.optional}>(Referencia del cargo)</span>
              </label>
              <select
                className={styles.selectField}
                value={formData.cicloEscolar}
                onChange={(e) => onFormChange('cicloEscolar', e.target.value)}
                required
              >
                <option value="">Seleccione un ciclo</option>
                {[...ciclosOptions]
                  .sort((a, b) => {
                    // Si ciclo es string tipo '2023-2024', ordena por valor descendente
                    if (a.ciclo && b.ciclo && typeof a.ciclo === 'string' && typeof b.ciclo === 'string') {
                      return b.ciclo.localeCompare(a.ciclo);
                    }
                    // Si tiene id_ciclo_escolar numérico, ordena por id descendente
                    return (b.id_ciclo_escolar || 0) - (a.id_ciclo_escolar || 0);
                  })
                  .map((ciclo) => (
                    <option key={ciclo.id_ciclo_escolar} value={ciclo.id_ciclo_escolar}>
                      {ciclo.ciclo}
                    </option>
                  ))}
              </select>
              {/* Leyenda eliminada por solicitud */}
            </div>

            {/* Campus */}
            <div className={styles.formField}>
              <label className={styles.fieldLabel}>
                <span className={styles.required}>*</span> Campus
              </label>
              <select
                className={styles.selectField}
                value={formData.campus}
                onChange={(e) => onFormChange('campus', e.target.value)}
                required
              >
                <option value="">Seleccione un campus</option>
                {campusOptions.map((campus) => (
                  <option key={campus.id} value={campus.id}>
                    {campus.nombre}
                  </option>
                ))}
              </select>
            </div>

            {/* Concepto de Cobro - filtrado por campus + ciclo escolar */}
            <div className={styles.formField}>
              <label className={styles.fieldLabel}>
                <span className={styles.required}>*</span> Concepto de Cobro
              </label>
              <select
                className={styles.selectField}
                value={formData.conceptoCobro}
                onChange={(e) => onFormChange('conceptoCobro', e.target.value)}
                required
                disabled={!formData.campus || !formData.cicloEscolar}
              >
                <option value="">
                  {!formData.campus
                    ? 'Primero seleccione un campus'
                    : !formData.cicloEscolar
                      ? 'Primero seleccione un ciclo escolar'
                      : conceptosOptions.length === 0
                        ? 'No hay conceptos para este campus y ciclo'
                        : 'Seleccione un concepto'}
                </option>
                {conceptosOptions.map((concepto) => (
                  <option key={concepto.id} value={concepto.id}>
                    {concepto.codigo} - {concepto.nombre}
                  </option>
                ))}
              </select>
              {formData.campus && formData.cicloEscolar && conceptosOptions.length === 0 && (
                <span className={styles.fieldHint} style={{ color: '#dc2626' }}>
                  No se encontraron conceptos de cobro para el campus y ciclo seleccionados
                </span>
              )}
            </div>

            {/* Sección (Filtro real para estudiantes) */}
            <div className={styles.formField}>
              <label className={styles.fieldLabel}>
                Sección <span className={styles.optional}>(Filtro de estudiantes)</span>
              </label>
              <select
                className={styles.selectField}
                value={formData.seccion}
                onChange={(e) => onFormChange('seccion', e.target.value)}
                disabled={!formData.campus}
              >
                <option value="">Todas las secciones</option>
                {seccionesOptions.map((seccion) => (
                  <option key={seccion.id} value={seccion.id}>
                    {seccion.nombre}
                  </option>
                ))}
              </select>
              <span className={styles.fieldHint}>
                Filtra los estudiantes activos por sección. Si no selecciona, incluye todas las secciones.
              </span>
            </div>

            {/* Fecha de Aplicación */}
            <div className={styles.formField}>
              <label className={styles.fieldLabel}>
                <span className={styles.required}>*</span> Fecha de Aplicación
              </label>
              <div className={styles.dateInputContainer}>
                <input
                  type="date"
                  className={styles.dateInput}
                  value={formData.fechaAplicacion}
                  onChange={(e) => onFormChange('fechaAplicacion', e.target.value)}
                  required
                />
                <div className={styles.calendarIcon}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                </div>
              </div>
            </div>

            {/* Fecha de Vencimiento */}
            <div className={styles.formField}>
              <label className={styles.fieldLabel}>
                <span className={styles.required}>*</span> Fecha de Vencimiento
              </label>
              <div className={styles.dateInputContainer}>
                <input
                  type="date"
                  className={styles.dateInput}
                  value={formData.fechaVencimiento}
                  onChange={(e) => onFormChange('fechaVencimiento', e.target.value)}
                  required
                  min={formData.fechaAplicacion}
                />
                <div className={styles.calendarIcon}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                </div>
              </div>
            </div>

          </div>

          {/* Información adicional */}
          <div className={styles.infoBox}>
            <div className={styles.infoIcon}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
              </svg>
            </div>
            <div className={styles.infoText}>
              <strong>Criterios de selección:</strong> Los cargos se generarán para estudiantes con estatus <strong>ACTIVO</strong>
              {formData.seccion ? ' en la sección seleccionada' : ' de cualquier sección en el campus seleccionado'}. 
              El ciclo escolar se asocia al cargo pero <strong>no filtra</strong> los estudiantes.
              El sistema validará que no se generen cargos duplicados. <strong>Debe hacer Vista Previa antes de generar.</strong>
            </div>
          </div>

          {/* Contador de estudiantes si hay preview */}
          {showPreview && previewCount > 0 && (
            <div className={styles.previewCounter}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
              </svg>
              <span><strong>{previewCount}</strong> estudiantes elegibles encontrados</span>
            </div>
          )}

          {/* Botones de acción */}
          <div className={styles.formActions}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={onCancel}
              disabled={loading || loadingPreview}
            >
              Cancelar
            </button>
            
            <button
              type="button"
              className={styles.previewButton}
              onClick={handlePreview}
              disabled={loading || loadingPreview}
            >
              {loadingPreview ? (
                <>
                  <span className={styles.spinner}></span>
                  Buscando...
                </>
              ) : (
                <>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                  Vista Previa
                </>
              )}
            </button>
            
            {showPreview && previewCount > 0 && (
              <button
                type="button"
                className={styles.csvButton}
                onClick={onDownloadCSV}
                disabled={loading}
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                  <polyline points="7 10 12 15 17 10"/>
                  <line x1="12" y1="15" x2="12" y2="3"/>
                </svg>
                Descargar CSV
              </button>
            )}
            
            <button
              type="submit"
              className={styles.generateButton}
              disabled={loading || loadingPreview || !showPreview || previewCount === 0}
            >
              {loading ? (
                <>
                  <span className={styles.spinner}></span>
                  Generando...
                </>
              ) : (
                <>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M9 11l3 3L22 4"/>
                    <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                  </svg>
                  Generar Cargos ({previewCount || 0})
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AutomaticChargeForm;
